/**
 * Convert rem values to numbers
 * @param remValue The rem value to convert (e.g. "1.5rem")
 * @returns The converted number value
 */
export const remToNumber = (remValue: string): number => {
  if (!remValue || typeof remValue !== 'string') return 0;
  return parseFloat(remValue.replace('rem', '')) * 16; // Assuming 1rem = 16px
};

/**
 * Convert px values to numbers
 * @param pxValue The px value to convert (e.g. "24px")
 * @returns The converted number value
 */
export const pxToNumber = (pxValue: string): number => {
  if (!pxValue || typeof pxValue !== 'string') return 0;
  return parseFloat(pxValue.replace('px', ''));
};
